import { h } from 'preact';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

// Components
import Steps from '../../Steps/index';
import Form from '../../Form/index';
import Modal from '../../Modal';
import { appModalActivatorAction } from '../../../actions/App';

const PageType = ({
  pageData,
  currentProgress,
  price,
  initialValues,
  modal,
  dispatch,
  userData,
  packageData,
  actions,
  currentSectionId,
}) => (
  <Form className="page" initialValues={initialValues} novalidate="novalidate">
    {/* Modal */}
    <Modal
      modalAction={actions.appModalActivatorAction}
      modalData={packageData.modals}
      currentProgress={currentProgress}
      modalState={modal}
      dispatch={dispatch}
      userData={userData}
      packageData={packageData}
      initialValues={initialValues}
    />
    <Steps
      pageData={pageData}
      price={price}
      currentProgress={currentProgress}
      currentSectionId={currentSectionId}
    />
  </Form>
);

export default compose(
  connect((state) => {
    const {
      userData,
      app: {
        modal,
      },
      section: {
        packageData,
      },
    } = state;

    return {
      userData,
      modal,
      packageData,
    };
  }, (dispatch) => ({
    actions: bindActionCreators({
      appModalActivatorAction,
    }, dispatch),
    dispatch,
  }))
)(PageType);

PageType.propTypes = {
  pageData: PropTypes.object.isRequired,
  currentProgress: PropTypes.object.isRequired,
  price: PropTypes.string.isRequired,
  currentSectionId: PropTypes.string.isRequired,
  initialValues: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  modal: PropTypes.object.isRequired,
  userData: PropTypes.object.isRequired,
  packageData: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Page/Page/index.jsx